import {ProductInterface as CatalogProductInterface} from "../interfaces/catalog/ProductInterface";
import {useContext} from "react";
import {ReducerStateInterface} from "../interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "../GlobalReducer";
import {ProductInterface} from "../interfaces/product/ProductInterface";

export default function useFavorite(product: CatalogProductInterface | ProductInterface) {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const inFavorites = () => {
        return state.favorites.map((item: CatalogProductInterface|ProductInterface) => item.id).includes(product.id);
    }

    const toggleFavorite = () => {
        if (inFavorites()) {
            dispatch({type: ReducerActionType.REMOVE_FROM_FAVORITES, payload: product});
        } else {
            dispatch({type: ReducerActionType.ADD_TO_FAVORITES, payload: product});
        }
    }

    return {inFavorites, toggleFavorite}
}